import { render, staticRenderFns } from "./CheckoutEmptyCart.vue?vue&type=template&id=b53112ac"
import script from "./CheckoutEmptyCart.vue?vue&type=script&lang=js"
export * from "./CheckoutEmptyCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports